import React from 'react';
import { PageHeader } from '../../components/shared/PageHeader';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Palette, Settings, Plus, Trash2 } from 'lucide-react';

export const DesignSystemPage: React.FC = () => {
  return (
    <div className="space-y-8">
      <PageHeader
        title="Design System"
        description="Component library and design tokens"
        icon={Palette}
      />

      <section>
        <h2 className="text-2xl font-bold mb-4">Buttons</h2>
        <p className="text-sm text-muted-foreground mb-4">
          Buttons use <code className="rounded bg-muted px-1">whitespace-nowrap</code> and{' '}
          <code className="rounded bg-muted px-1">flex-shrink-0</code> to prevent text overflow. Use{' '}
          <code className="rounded bg-muted px-1">size=&quot;sm&quot;</code> for header actions.
        </p>
        <div className="flex flex-wrap gap-4">
          <Button>Default</Button>
          <Button variant="outline">Outline</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="destructive">Destructive</Button>
          <Button variant="success">Success</Button>
          <Button size="sm">Small</Button>
          <Button size="lg">Large</Button>
          <Button loading>Loading</Button>
        </div>
        <div className="mt-4">
          <p className="text-sm font-medium mb-2">Icon + text (header actions)</p>
          <div className="flex flex-wrap gap-2">
            <Button variant="outline" size="sm">
              <Settings className="h-4 w-4" />
              Edit
            </Button>
            <Button variant="outline" size="sm">
              <Plus className="h-4 w-4" />
              Add Item
            </Button>
            <Button variant="destructive" size="sm">
              <Trash2 className="h-4 w-4" />
              Delete
            </Button>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4">Badges</h2>
        <div className="flex flex-wrap gap-4">
          <Badge variant="default">Default</Badge>
          <Badge variant="success">Success</Badge>
          <Badge variant="warning">Warning</Badge>
          <Badge variant="error">Error</Badge>
          <Badge variant="outline">Outline</Badge>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4">Inputs</h2>
        <div className="space-y-4 max-w-md">
          <Input label="Text Input" placeholder="Enter text..." />
          <Input label="Email Input" type="email" placeholder="email@example.com" />
          <Input label="With Error" error="This field is required" />
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4">Cards</h2>
        <div className="grid grid-cols-3 gap-4">
          <Card>
            <CardHeader>
              <CardTitle>Card Title</CardTitle>
            </CardHeader>
            <CardContent>
              <p>Card content goes here</p>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>Another Card</CardTitle>
            </CardHeader>
            <CardContent>
              <p>More content</p>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>Third Card</CardTitle>
            </CardHeader>
            <CardContent>
              <p>Even more content</p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};
